import React from "react"

export default function useUpdateState(
  prop: any, 
  updateState: React.Dispatch<React.SetStateAction<any>>
) {
  React.useEffect(() => {
    if(prop == undefined) return;
    updateState(prop)
  }, [prop])
}
